import { ShieldCheck, Users, Sparkles, Award } from "lucide-react";

export default function TrustStrip() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3" data-testid="trust-strip">
      <div className="flex items-center gap-2 text-[#04273d]">
        <Users size={16} />
        <span className="font-mono-brand text-[11px] tracking-widest uppercase">2000+ UK businesses protected</span>
      </div>
      <span className="h-1 w-1 rounded-full bg-[#9ac7f7]/60" />
      <div className="flex items-center gap-2 text-[#04273d]">
        <Award size={16} />
        <span className="font-mono-brand text-[11px] tracking-widest uppercase">A NBR Group Service</span>
      </div>
      <span className="h-1 w-1 rounded-full bg-[#9ac7f7]/60" />
      <div className="flex items-center gap-2 text-[#04273d]">
        <Sparkles size={16} />
        <span className="font-mono-brand text-[11px] tracking-widest uppercase">From £15 per month</span>
      </div>
      <span className="h-1 w-1 rounded-full bg-[#9ac7f7]/60" />
      <div className="flex items-center gap-2 text-[#04273d]">
        <ShieldCheck size={16} />
        <span className="font-mono-brand text-[11px] tracking-widest uppercase">UK only, GDPR compliant</span>
      </div>
    </div>
  );
}
